"use client";

import dynamic from "next/dynamic";

// The calendar (react-day-picker with date-fns) only shows inside a booking
// dialog or a form with a date field. Loaded then, not with every page.
export const Calendar = dynamic(() => import("./calendar").then((m) => m.Calendar), {
  ssr: false,
  loading: () => <div className="min-h-[19rem]" aria-hidden="true" />,
});
